import { IUser } from 'interface/user';
import { BehaviorSubject, Subject } from 'rxjs';
import { first, filter, debounceTime } from 'rxjs/operators';
import { API_SOCKET_URL } from 'settings';
import io from 'socket.io-client';
import { getStore } from 'redux/store';
import { isSubdomain } from 'utils/domain';

export let socket: ReturnType<typeof io>;
const connection$ = new BehaviorSubject(false);

/**
 *
 * @param additionalData
 * @param context The app/module/action in the event data
 * @param environment The elastic search index suffix
 */
export function emitLog(additionalData: any, context: string, environment: string) {
  connection$
    .pipe(
      filter((connected) => connected),
      first()
    )
    .subscribe(() =>
      socket.emit('log', {
        additionalData,
        context,
        environment,
      })
    );
}

export function userIdentified(user: IUser) {
  connection$
    .pipe(
      filter((connected) => connected),
      first()
    )
    .subscribe(() => socket.emit('user-identified', user));
}

export function initSocket(store: ReturnType<typeof getStore>) {
  socket = io(API_SOCKET_URL, {
    query: {
      context: 'learner',
      sessionid: localStorage.getItem('socketSessionId'),
    },
    reconnectionDelay: 60000,
    reconnectionDelayMax: 300000,
  });

  socket.on('connect', () => connection$.next(true));
  socket.on('disconnect', () => connection$.next(false));

  socket.on('learner-user-count-updated', (count: number) => {
    store.dispatch({ type: 'RECEIVE_USER_SESSION_COUNT', count });
  });

  const updateShelve$ = new Subject();
  updateShelve$.pipe(
    debounceTime(700)
  ).subscribe(() => {
    store.dispatch({ type: 'showcase/updateShelves' });
  });
  socket.on('updateShelve', ({ domain, portal }: { portal: string, domain: string }) => {
    const isPortal = isSubdomain(window.location.host);
    const shouldDispatchEvent = (!portal && !isPortal) ||
      (domain && isPortal && new URL(domain).hostname == window.location.hostname);
    if (shouldDispatchEvent) {
      updateShelve$.next(true);
    }
  });

  socket.on('learner-user-count-lesson', (count: number) => {
    store.dispatch({ type: 'RECEIVE_USER_LESSONPAGE_COUNT', count });
  });

  socket.on('learner-sessionid', (socketSessionId: string) => {
    localStorage.setItem('socketSessionId', socketSessionId);
    store.dispatch({ type: 'RECEIVE_USER_SESSIONID', socketSessionId });
  });

  socket.on('logout', async (sessionId: string) => {
    const mySessionId = localStorage.getItem('socketSessionId');
    if (sessionId !== mySessionId) {
      store.dispatch({ type: 'LOGOUT' });
    }
  });
}
